import { useContext } from 'react'
import { SnackbarContext, type SnackbarContextValue } from './SnackbarProvider'

/**
 * Snackbar キュー用 hook。基本は {@link SnackbarProvider} 配下で呼ぶ。
 *
 * notistack の `useSnackbar` と同じシグネチャを返すため、import 行を
 * `from 'notistack'` から `from 'shared/ui/Snackbar'` に切り替えるだけで移行可能。
 *
 * Provider 未配置時は no-op を返す（notistack 互換）。テスト用 renderHook 等で
 * Provider を省略するケースに対応するため、エラーは投げない。
 */
export const useSnackbar = (): SnackbarContextValue => {
  return useContext(SnackbarContext)
}
